import { createAsyncThunk } from '@reduxjs/toolkit';
import { CropImageDocumentSignalRResponse } from '@v2/components/imageHandling/types/types';
import { AppDispatch } from '@store/types';
import { pushMessage } from '@reducers/v2/messagesBus/messagesBus.slice';
import { ImageDocumentMessageType } from '@reducers/v2/messagesBus/types';

export const cropImageDocumentMessageProducer = createAsyncThunk<void, CropImageDocumentSignalRResponse, { dispatch: AppDispatch }>(
  'imageHandlingV2/cropImageDocumentMessageProducer',
  async ({ cropSettings, documentId, isError }, { dispatch }) => {
    //TODO: handle error
    if (!isError) {
      dispatch(
        pushMessage({
          key: documentId,
          message: {
            messageType: ImageDocumentMessageType.IMAGE_CROPPED,
            payload: { documentId, cropSettings },
          },
        })
      );
    }
  }
);
